@if (content) {
<ng-container *ifNotCheckoutProcess>
    <page-header-promobar *ifSize="'MS'"
                          [content]="content"></page-header-promobar>
    <div class="bg-col-1 col-w _topBanner pos-relative z-10"
         *ifSize="'XL'"
         [elementHeight]="'header-top-bar'"
         #topBanner>
        <div class="wrap flex">

            @if(!content.hideTab) {
            <div class="p-t-1 flex">
                @if(content.firstTabImage) {
                <href class="p-a-1"
                      [ngClass]="{'bg-col-6 _radiusTop' : content.firstActivated}"
                      [link]="content.firstTabLink"
                      [hrefTarget]="'_self'"
                      [hrefOff]="content.firstActivated">

                    <img [loaderParams]="{fitIn: true, fillColor: 'transparent'}"
                         [width]="44"
                         [height]="21"
                         [dfImage]="content.firstTabImage">

                </href>
                }
                @if(content.secondTabImage) {
                <href class="m-l-1 p-a-1"
                      [ngClass]="{'bg-col-w _radiusTop' : !content.firstActivated}"
                      [link]="content.secondTabLink"
                      [hrefTarget]="'_self'"
                      [hrefOff]="!content.firstActivated">

                    <img [loaderParams]="{fitIn: true, fillColor: 'transparent'}"
                         [width]="63"
                         [height]="21"
                         [dfImage]="content.secondTabImage">

                </href>
                }
            </div>
            }
            <div class="flex-grow"></div>
            <div class="flex flex-middle m-t-1 m-b-1">
                @for(link of content?.topLinks; track $index) {
                <href [link]="link?.link">
                    <p class="c1 p-a-1 p-l-5 p-r-5 b-r b-col-11 _top-banner-link">{{link.text}}</p>
                </href>
                }
                <div class="flex flex-middle">
                    <p class="c1 p-a-1 p-l-5">{{'VAT:' | translate}}</p>
                    <toggle class="p-l-2">
                        <input type="checkbox"
                               [(ngModel)]="vatSelected"
                               (ngModelChange)="toggleVat()"
                               [name]="'toggle'" />
                    </toggle>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<header class="w-12 page-header">
    <sticky-free [order]="0"
                 [stickyOff]="isStickyOff"
                 [style.z-index]="11">
        <div class="_content"
             [elementHeight]="headerContentId">
            <div class="z-2 bg-col-6 pos-relative">
                <div class="_shadow"
                     [toggleClass]="'is-active'"
                     [toggleClassBy]="toggleGroupId"
                     *ifSize="'XL'">
                    <div></div>
                </div>
                <ng-container *ifNotCheckoutProcess>
                    <!-- menu / S, M -->
                    <div class="w-12"
                         *ifSize="'MS'">
                        <div class="w-12 flex flex-justify-between p-a p-t-3 p-b-3">
                            <div class="flex">
                                <!-- menu toggle -->
                                <button type="button"
                                        aria-label="Menu"
                                        class="_icon-wrapper m-l-0"
                                        (click)="openOffCanvas()">
                                    <i class="icon-menu"
                                       aria-hidden="true"></i>
                                </button>
                                <!-- logo -->
                                <div class="m-l">
                                    <ng-container [ngTemplateOutlet]="logo"></ng-container>
                                </div>
                            </div>
                            <div class="flex"
                                 [class._visibilityOff]="!isCustomerLoaded">
                                <ng-container [ngTemplateOutlet]="accountBtn"></ng-container>
                                <!-- basket -->
                                <div class="flex-span-1 right">
                                    <a [routerLink]="'/basket'"
                                       class="_icon-wrapper">
                                        <ng-container [ngTemplateOutlet]="basketBtn"></ng-container>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="w-12 p-a p-t-2 p-b-2">
                            <!-- search -->
                            <button (click)="openOffCanvasSearch()"
                                    aria-label="Search"
                                    cy-searchbutton
                                    class="w-12 flex flex-middle bg-col-51 p-a-3 p-l-4 p-r-4"
                                    style="border-radius: 4px;">
                                <i class="_placeholderIcon search-icon icon-search cursor-pointer"
                                   aria-hidden="true"></i>
                                <p class="p1 col-4 p-l-3">
                                    {{'Search for a product' | translate}}
                                </p>
                            </button>
                        </div>

                    </div>
                    <!-- menu / X, L -->
                    <div class="wrap flex-middle flex bg-col-6">
                        <div class="w-12"
                             *ifSize="'XL'"
                             [elementHeight]="'menuWithMeganav'">
                            <div class="w-12 p-t p-b flex flex-justify-between flex-middle"
                                 [elementHeight]="'header-menu'">
                                <div class="w-7 flex flex-middle">
                                    <!-- logo -->
                                    <ng-container [ngTemplateOutlet]="logo"></ng-container>

                                    <!-- search -->
                                    <page-header-search-form (isFormVisible)="onSearchFormVisibilityChange($event)"
                                                             class="w-12"></page-header-search-form>
                                </div>
                                <div class="flex flex-middle"
                                     [class._visibilityOff]="!isCustomerLoaded">
                                    <button class="flex flex-middle m-l-8"
                                            [iCmsModalOpen]="DELIVERY_MODAL_ID">
                                        <i class="icon-delivery inline-flex"></i>
                                        @if(deliveryPostcode.postcode()) {
                                        <p class="c1 p-l-1 no-wrap">{{deliveryPostcode.postcode()}}</p>
                                        } @else {
                                        <p class="c1 p-l-1 no-wrap">{{'Enter postcode' | translate}}</p>
                                        }
                                    </button>
                                    <button class="flex flex-middle m-l-8"
                                            [iCmsModalOpen]="BRANCH_MODAL_ID">
                                        <i class="icon-branch inline-flex"></i>
                                        <p class="c1 p-l-1 no-wrap">{{(branchName || 'Select Branch')
                                            | translate}}
                                        </p>
                                    </button>
                                    <a class="flex flex-middle m-l-8"
                                       [routerLink]="'login'"
                                       *ifNotLoggedIn>
                                        <i class="icon-account"></i>
                                        <p class="c1 p-l-1 no-wrap">{{'Log in or sign up' | translate}}</p>
                                    </a>
                                    <a class="flex flex-middle m-l-8"
                                       [routerLink]="'account'"
                                       *ifLoggedIn>
                                        <i class="icon-account inline-flex"></i>
                                        <p class="c1 p-l-1 no-wrap">{{'Hi' | translate}},
                                            {{customerModel.data.firstname}}</p>
                                    </a>
                                    <a class="flex flex-middle m-l-8 p-l-8 b-l b-col-1"
                                       [routerLink]="'basket'">
                                        <i pageHeaderBasketQtyBullet
                                           class="icon-basket inline-flex"></i>
                                        <p class="c1 p-l-1 no-wrap">{{'Basket' | translate}}</p>
                                    </a>
                                </div>
                            </div>
                            <div class="_hideOnSearch">
                                <!-- meganav -->
                                <page-header-meganav-menu *ifSize="'XL'"
                                                          class="flex-grow"
                                                          [content]="content"></page-header-meganav-menu>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <!-- Checkout header-->
                <div *ifCheckoutProcess
                     class="wrap p-t-3 p-b-3 flex-middle flex">
                    <div class="flex-span-1 flex flex-middle">
                        <i class="icon-lock"></i>
                        <p class="p1 m-l"
                           *ifSize="'XL'">Secure Checkout</p>
                    </div>
                    <!-- logo -->
                    <div [sizeClass]="'flex-grow center'">
                        <a class="inline-block pos-relative"
                           routerLink="/">
                            <img [width]="client.isX || client.isL ? 186 : 150"
                                 [height]="client.isX || client.isL ? 35 : 28"
                                 [dfImage]="content.logo"
                                 [loaderParams]="{fitIn: true}">
                        </a>
                    </div>
                    <div class="flex-span-1"></div>
                </div>
            </div>
            <!-- meganav content -->
            <ng-container *afterContentInit>
                <page-header-shop-submenu-content *ifSize="'XL'"
                                                  [items]="content.shopSubmenu"
                                                  [promobannerBlocks]="content.promobannerBlocks"
                                                  [promobannerBackround]="content.promobannerBackround"
                                                  [promobannerColor]="content.promobannerColor"
                                                  class="block z-1">
                    <div class="w-12 m-t ratio-9-7 _bannerImage b-radius-4">
                        <img [ratio]="'ratio-9-7'"
                             [dfImage]="content.promoImage"
                             [fill]="true"
                             class="b-radius-4">
                        <div class="pos-absolute bottom-0 w-12 z-1 p-a">
                            <p class="h4 col-w m-b-2 yes-wrap"
                               *iCms="'promoText' of content"></p>
                            <href [link]="content.promoButtonLink">
                                <button [buttonStyle]>
                                    <span *iCms="'promoButtonCopy' of content"></span>
                                </button>
                            </href>
                        </div>
                    </div>
                </page-header-shop-submenu-content>
                <page-header-meganav-content *ifSize="'XL'"
                                             class="block z-1"
                                             [content]="content">
                </page-header-meganav-content>
            </ng-container>
        </div>
    </sticky-free>
</header>
<ng-container *ifNotCheckoutProcess>
    <div *ifSize="'MS'"
         class="flex flex-justify-between p-a p-t-2 p-b-2 bg-col-6">
        <button class="flex flex-middle"
                [iCmsModalOpen]="DELIVERY_MODAL_ID">
            <i class="icon-delivery inline-flex icon-medium"></i>
            @if(deliveryPostcode.postcode()) {
            <p class="c1 p-l-1 no-wrap">{{deliveryPostcode.postcode()}}</p>
            } @else {
            <p class="c1 p-l-1 no-wrap">{{'Delivery address' | translate}}</p>
            }
        </button>
        <button class="flex flex-middle"
                [iCmsModalOpen]="BRANCH_MODAL_ID">
            <i class="icon-branch inline-flex icon-medium"></i>
            <p class="c1 p-l-1 no-wrap">{{ branchName || ('Collection branch' | translate) }}</p>
        </button>
    </div>
    <page-header-promobar *ifSize="'XL'"
                          [content]="content"></page-header-promobar>
</ng-container>
}
<ng-template #basketBtn>
    <span pageHeaderBasketQtyBullet
          class="inline-block"><i class="icon-basket"
           aria-hidden="true"></i></span>
</ng-template>

<ng-template #accountBtn>
    <!-- my account -->
    <a routerLink="/account"
       cy-loginbutton
       *ifLoggedIn
       title="My Account"
       class="_icon-wrapper"><i class="icon-account"
           aria-hidden="true"></i></a>
    <!-- sign in -->
    <a routerLink="/login"
       routerLinkActive="is-active"
       cy-loginbutton
       *ifNotLoggedIn
       title="Sign In"
       class="_icon-wrapper">
        <i class="icon-account"
           aria-hidden="true"></i>
    </a>
</ng-template>

<ng-template #logo>
    <div [sizeClass]="'XL:flex-noshrink m-r-8, SM:flex flex-grow center'"
         class="inline-block pos-relative z-3"
         [style.height.px]="client.sizeId < 2 ? 28 : 48">
        <a class="inline-block pos-relative _logo"
           routerLink="/">
            <img [dfImage]="content.logo"
                 [loaderParams]="{fitIn: true}"
                 [width]="client.sizeId < 2 ? 60 : 100"
                 [height]="client.sizeId < 2 ? 28 : 48">
        </a>
    </div>
</ng-template>